export const FETCH_CREATE_NEWSLETTER = 'CREATE_NEWSLETTER',
FETCH_NEWSLETTER = 'FETCH_NEWSLETTER',
FETCH_NEWSLETTER_HISTORY = 'FETCH_NEWSLETTER_HISTORY',
FETCH_NEWSLETTER_HISTORY_SUCCESS = 'FETCH_NEWSLETTER_HISTORY_SUCCESS',
FETCH_DELETE_NEWSLETTER = 'FETCH_DELETE_NEWSLETTER',
FETCH_DELETE_NEWSLETTER_SUCCESS = 'FETCH_DELETE_NEWSLETTER_SUCCESS',
FETCH_SEND_NEWSLETTER = 'FETCH_SEND_NEWSLETTER',
FETCH_SEND_NEWSLETTER_SUCCESS = 'FETCH_SEND_NEWSLETTER_SUCCESS',
UPDATE_NEWSLETTER = 'UPDATE_NEWSLETTER';